export default __webpack_public_path__ + "static/media/solucao-09.c4196538.webp";